export default "__VITE_ASSET__BOIR8Bl1__"